import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AdminContingentManagementService } from './api/adminContingentManagement.service';
import { AdminMyCheckKatalogService } from './api/adminMyCheckKatalog.service';
import { AdminOrganisationManagementService } from './api/adminOrganisationManagement.service';
import { AdminRuleTestManagementService } from './api/adminRuleTestManagement.service';
import { AdminSearchIndexManagementService } from './api/adminSearchIndexManagement.service';
import { AdminStatisticsService } from './api/adminStatistics.service';
import { AdminUserManagementService } from './api/adminUserManagement.service';
import { AuthControllerService } from './api/authController.service';
import { BillingControllerService } from './api/billingController.service';
import { BimBaseCheckControllerService } from './api/bimBaseCheckController.service';
import { CatalogControllerService } from './api/catalogController.service';
import { ChatControllerService } from './api/chatController.service';
import { ChatTurnControllerService } from './api/chatTurnController.service';
import { CheckResultControllerService } from './api/checkResultController.service';
import { CheckRuleControllerService } from './api/checkRuleController.service';
import { CheckRunScheduleControllerService } from './api/checkRunScheduleController.service';
import { ContingentUsageControllerService } from './api/contingentUsageController.service';
import { DashboardControllerService } from './api/dashboardController.service';
import { DocumentClassControllerService } from './api/documentClassController.service';
import { ExternalConnectionControllerService } from './api/externalConnectionController.service';
import { FoundryModelsControllerService } from './api/foundryModelsController.service';
import { GlobalCheckRuleControllerService } from './api/globalCheckRuleController.service';
import { GlobalCheckRuleSetControllerService } from './api/globalCheckRuleSetController.service';
import { GlobalWorkflowDefinitionControllerService } from './api/globalWorkflowDefinitionController.service';
import { HoaiCheckControllerService } from './api/hoaiCheckController.service';
import { IfcControllerService } from './api/ifcController.service';
import { ModuleFunctionControllerService } from './api/moduleFunctionController.service';
import { MyCheckProjectShareControllerService } from './api/myCheckProjectShareController.service';
import { MyCheckProposalControllerService } from './api/myCheckProposalController.service';
import { MyCheckQuotaControllerService } from './api/myCheckQuotaController.service';
import { MyCheckShareControllerService } from './api/myCheckShareController.service';
import { OrganisationControllerService } from './api/organisationController.service';
import { ProjectControllerService } from './api/projectController.service';
import { ProjectFileControllerService } from './api/projectFileController.service';
import { QualityControllerService } from './api/qualityController.service';
import { RuleTestControllerService } from './api/ruleTestController.service';
import { RulesetProjectShareControllerService } from './api/rulesetProjectShareController.service';
import { RulesetTransferControllerService } from './api/rulesetTransferController.service';
import { ServiceControllerService } from './api/serviceController.service';
import { SourceLinkControllerService } from './api/sourceLinkController.service';
import { StateControllerService } from './api/stateController.service';
import { StatusService } from './api/status.service';
import { TaskControllerService } from './api/taskController.service';
import { TokenUsageControllerService } from './api/tokenUsageController.service';
import { UserControllerService } from './api/userController.service';
import { UserPreferenceControllerService } from './api/userPreferenceController.service';
import { VersionHistoryControllerService } from './api/versionHistoryController.service';
import { WorkflowCheckRuleControllerService } from './api/workflowCheckRuleController.service';
import { WorkflowDefinitionControllerService } from './api/workflowDefinitionController.service';
import { WorkflowInstanceControllerService } from './api/workflowInstanceController.service';
import { WorkflowPinControllerService } from './api/workflowPinController.service';
import { WorkflowRegistryControllerService } from './api/workflowRegistryController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AdminContingentManagementService,
    AdminMyCheckKatalogService,
    AdminOrganisationManagementService,
    AdminRuleTestManagementService,
    AdminSearchIndexManagementService,
    AdminStatisticsService,
    AdminUserManagementService,
    AuthControllerService,
    BillingControllerService,
    BimBaseCheckControllerService,
    CatalogControllerService,
    ChatControllerService,
    ChatTurnControllerService,
    CheckResultControllerService,
    CheckRuleControllerService,
    CheckRunScheduleControllerService,
    ContingentUsageControllerService,
    DashboardControllerService,
    DocumentClassControllerService,
    ExternalConnectionControllerService,
    FoundryModelsControllerService,
    GlobalCheckRuleControllerService,
    GlobalCheckRuleSetControllerService,
    GlobalWorkflowDefinitionControllerService,
    HoaiCheckControllerService,
    IfcControllerService,
    ModuleFunctionControllerService,
    MyCheckProjectShareControllerService,
    MyCheckProposalControllerService,
    MyCheckQuotaControllerService,
    MyCheckShareControllerService,
    OrganisationControllerService,
    ProjectControllerService,
    ProjectFileControllerService,
    QualityControllerService,
    RuleTestControllerService,
    RulesetProjectShareControllerService,
    RulesetTransferControllerService,
    ServiceControllerService,
    SourceLinkControllerService,
    StateControllerService,
    StatusService,
    TaskControllerService,
    TokenUsageControllerService,
    UserControllerService,
    UserPreferenceControllerService,
    VersionHistoryControllerService,
    WorkflowCheckRuleControllerService,
    WorkflowDefinitionControllerService,
    WorkflowInstanceControllerService,
    WorkflowPinControllerService,
    WorkflowRegistryControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
